import { render, staticRenderFns } from "./AlteraSenha.vue?vue&type=template&id=b065008e&"
import script from "./AlteraSenha.vue?vue&type=script&lang=js&"
export * from "./AlteraSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports